import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
    } = config;
    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;

    if (this.accordions && this.accordions.length !== 0) {
      this.bindEvents();
    }

    const url = location.href;
    const id = url.split('#');

    if (id[1]) {
      let accordionToClick = null;
      let targetAnchor = document.querySelector('#' + id[1]);

      if (targetAnchor) {
        let accordion = this.getClosestAccordion(targetAnchor);

        if (accordion && this.getClosestAccordion(accordion.parentElement)) {
          accordion = this.getClosestAccordion(accordion.parentElement);
        }

        if (accordion) {
          accordionToClick = accordion.querySelector('.js-toggle-accordion');
        } else {
          this.scrollTo(targetAnchor);
        }
      }

      //console.log('#accordion'+id[1]+' .js-toggle-accordion');
      if (!accordionToClick) {
        accordionToClick = document.querySelector('#accordion' + id[1] + ' .js-toggle-accordion');
      }


      if (accordionToClick) {
        accordionToClick.click();
        setTimeout(() => {
          if (targetAnchor) {
            this.scrollTo(targetAnchor);
          }
          else {
            this.scrollTo(accordionToClick);
          }
        }, 1000)
      } else if (targetAnchor) {
        this.scrollTo(targetAnchor);
      }
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        const accordionContent = el.nextElementSibling;
        console.log(accordionContent)
        if (el.classList.contains('active')) {
          Helper.slideClose(accordionContent);
          el.classList.remove('active');
        } else {
          el.classList.add('active');
          Helper.slideOpen(accordionContent, true)
          console.log(accordionContent)
        }
      });
    });
  }

  scrollTo(el) {
    if (el) {
      window.scrollTo({
        top: Helper.getOffsetTop(el) + window.scrollY - 80,
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  getClosestAccordion(targetAnchor) {
    return targetAnchor.closest('.mms-accordion-container');
  }

}

export default Accordion;
